<div class="info variant-1 mt-4 mt-lg-0 mb-4 d-flex align-items-center">
  <div class="mr-3 m-3">
    <img src="favicons/apple-icon-57x57.png" alt="" />
  </div>
  <div>
    <h3 class="mb-3">{{ 'login.default.secureAppInfo.header' | transloco }}</h3>
    <p>
      {{ 'login.default.secureAppInfo.message1' | transloco }}
      <a [href]="URL_APPSTORE_APPLE" target="_blank" rel="noopener noreferrer nofollow">Apple</a>
      {{ 'login.default.secureAppInfo.message2' | transloco }}
      <a [href]="URL_APPSTORE_GOOGLE" target="_blank" rel="noopener noreferrer nofollow">Android</a>
    </p>
  </div>
</div>
